// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falDistributeSpacingHorizontal: CreateIconOptions = {
  "displayName": "FALDistributeSpacingHorizontal",
  "viewBox": "0, 0, 512, 512",
  "d": "M464 0c-8.8 0-16 7.2-16 16l0 480c0 8.8 7.2 16 16 16s16-7.2 16-16l0-480c0-8.8-7.2-16-16-16zM320 368c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16l0 224zm32-224c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-224zM64 16C64 7.2 56.8 0 48 0S32 7.2 32 16l0 480c0 8.8 7.2 16 16 16s16-7.2 16-16L64 16z"
};
